import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import DatePicker from "react-datepicker";
import moment from "moment";
import { 
  monthSelectOptions
} from "../../variables/Variables.jsx";
import {
  generateBirthdayReportRequest,
  generateUndertimeReportRequest,
  generateTardinessReportRequest,
  generateHabitualTardinessReportRequest,
  generateAwolReportRequest,
  generateAbsencesReportRequest,
  generatePagIbigReportRequest,
  generatePhicReportRequest,
  generateSSSReportRequest,
  generateLeaveBalanceReportRequest
} from "../../api/report";
import BirthdayReport from "./BirthdayReport.jsx";
import UndertimeReport from "./UndertimeReport.jsx";
import TardinessReport from "./TardinessReport.jsx";
import HabitualTardinessReport from "./HabitualTardinessReport.jsx";
import AbsencesReport from "./AbsencesReport.jsx";
import AwolReport from "./AwolReport.jsx";
import SSSReport from "./SSSReport.jsx";
import PhicReport from "./PhicReport.jsx";
import PagIbigReport from "./PagIbigReport.jsx";
import LeaveBalanceReport from "./LeaveBalanceReport.jsx";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect.jsx";

class Report extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedAction: '',
      selectedMonth: '',
      selectedMonthYear: '',
      selectedYear: moment().year(),
      startDate: '',
      endDate: '',
      successMessage: null,
      errorMessage: null,
      reportData: null,
      employees: [],
    }
  }

  handleActionSelect = (e) => {
    const { target } = e;
    const { name, value } = target;

    if (name === "selectedAction") {
      this.setState({
        [name]: value,
        formErrors: null,
        reportData: null,
        selectedMonth: '',
        selectedMonthYear: ''
      })
    } else {
      this.setState({
        [name]: value,
        formErrors: null
      })
    }
  }

  handleDateChange = (date, field) => {
    this.setState({
      [field]: date
    });
  }

  onChangeDate = (date, field) => {
    let value = moment(date).format("YYYY-MM-DD");

    this.setState({
      [field]: value
    });
  };

  generateBirthdayReport = (month) => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const { employees } = this.state;

    const data = {
      month,
      employees
    }

    generateBirthdayReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "Birthday Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generateUndertimeReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const {
      startDate,
      endDate,
      employees
    } = this.state;

    const data = {
      startDate,
      endDate,
      employees
    }

    generateUndertimeReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "Undertime Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generateTardinessReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const {
      startDate,
      endDate,
      employees
    } = this.state;

    const data = {
      startDate,
      endDate,
      employees
    }

    generateTardinessReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "Tardiness Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generateHabitualTardinessReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const {
      selectedYear,
      employees
    } = this.state;

    const data = {
      year: selectedYear,
      employees
    }

    generateHabitualTardinessReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "Habitual Tardiness Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generateAbsencesReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const {
      startDate,
      endDate,
      employees
    } = this.state;

    const data = {
      startDate,
      endDate,
      employees
    }

    generateAbsencesReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "Absences Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generateAwolReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const {
      selectedYear,
      employees
    } = this.state;

    const data = {
      year: selectedYear,
      employees
    }

    generateAwolReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "AWOL Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generatePagIbigReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const {
      startDate,
      endDate,
      employees
    } = this.state;

    const data = {
      startDate,
      endDate,
      employees
    }

    generatePagIbigReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "Pag-Ibig Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generatePhicReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const {
      startDate,
      endDate,
      employees
    } = this.state;

    const data = {
      startDate,
      endDate,
      employees
    }

    generatePhicReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "PHIC Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generateSSSReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const {
      startDate,
      endDate,
      employees
    } = this.state;

    const data = {
      startDate,
      endDate,
      employees
    }

    generateSSSReportRequest(data,
      result => this.setState({ 
        errorMessage: null,
        successMessage: "SSS Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({ 
        errorMessage: "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  generateLeaveBalanceReport = () => {
    this.setState({
      loading: true,
      formErrors: null,
      reportData: null
    });

    const { selectedYear, employees } = this.state;
    generateLeaveBalanceReportRequest(
      { year: selectedYear, employees },
      result => this.setState({
        errorMessage: null,
        successMessage: "Leave Balance Report generated successfully",
        reportData: result,
        loading: false
      }),
      error => this.setState({
        errorMessage: error.message || "There was an error generating report",
        successMessage: null,
        reportData: null,
        loading: false
      })
    );
  }

  handleEmployeesChange = (employees) => {
    this.setState({ employees: employees ? employees.map(emp => emp.value) : [] });
  }

  render() {

    const { 
      selectedAction,
      selectedMonth,
      selectedYear,
      reportData,
      loading
    } = this.state;

    const startDate = this.state.startDate ? moment(this.state.startDate, 'YYYY-MM-DD').toDate() : '';
    const endDate = this.state.endDate ? moment(this.state.endDate, 'YYYY-MM-DD').toDate() : '';

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <FormGroup controlId="formControlsSelect">
                <ControlLabel>Select Report</ControlLabel>
                <FormControl 
                    onChange={this.handleActionSelect}
                    componentClass="select" 
                    name="selectedAction"
                    value={selectedAction}
                  >
                  <option value="">Select</option>
                  <option value="birthday">Birthday Report</option>
                  <option value="undertime">Undertime Report</option>
                  <option value="absences">Absences Report</option>
                  <option value="tardiness">Tardiness Report</option>
                  <option value="habitual-tardiness">Habitual Tardiness Report</option>
                  <option value="awol">AWOL Report</option>
                  <option value="pag-ibig">Pag-Ibig Report</option>
                  <option value="phic">PHIC Report</option>
                  <option value="sss">SSS Report</option>
                  <option value="leave-balance">Leave Balance Report</option>
                  <option value="summary">Month Summary Report</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          {selectedAction === "birthday" &&
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>Select Month</ControlLabel>
                  <FormControl 
                      onChange={this.handleActionSelect}
                      componentClass="select" 
                      name="selectedMonth"
                      value={selectedMonth}
                    >
                    <option value="">Select</option>
                    {monthSelectOptions.map(option => {
                        return (
                            <option
                            key={option.value}
                            value={option.value}
                            >
                            {option.label}
                            </option>
                        );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
          }
          {(
            selectedAction === "leave-balance" ||
            selectedAction === "habitual-tardiness" ||
            selectedAction === "awol"
          ) &&
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>{selectedAction === "leave-balance" ? "Balance Year" : "Year"}</ControlLabel>
                  <FormControl
                    type="number"
                    min="1900"
                    max="9999"
                    name="selectedYear"
                    value={selectedYear}
                    onChange={this.handleActionSelect}
                  />
                </FormGroup>
              </Col>
            </Row>
          }
          {(
            selectedAction === "undertime" || 
            selectedAction === "absences" || 
            selectedAction === "tardiness" ||
            selectedAction === "phic" || 
            selectedAction === "pag-ibig" || 
            selectedAction === "sss"
          ) &&
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Start Date</ControlLabel>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => this.onChangeDate(date,'startDate')}
                    dateFormat="MM/dd/yyyy"
                    className="dateInput"
                    dropdownMode="select"
                    showYearDropdown
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>End Date</ControlLabel>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => this.onChangeDate(date,'endDate')}
                    dateFormat="MM/dd/yyyy"
                    className="dateInput"
                    dropdownMode="select"
                    showYearDropdown
                  />
                </FormGroup>
              </Col>
            </Row>
          }
          {selectedAction && selectedAction !== "birthday" &&
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>Employees</ControlLabel>
                  <p className="text-muted">
                    Leave empty to generate report for all employees
                  </p>
                  <EmployeeAsyncSelect
                    isMulti
                    onChange={this.handleEmployeesChange}
                  />
                </FormGroup>
              </Col>
            </Row>
          }
          {selectedAction === "birthday" && selectedMonth &&
            <Button bsStyle="primary" pullRight fill onClick={() => this.generateBirthdayReport(selectedMonth)}>
                {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "undertime" && startDate && endDate && 
            <Button bsStyle="primary" pullRight fill onClick={() => this.generateUndertimeReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "tardiness" && startDate && endDate && 
            <Button bsStyle="primary" pullRight fill onClick={() => this.generateTardinessReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "habitual-tardiness" && selectedYear &&
            <Button bsStyle="primary" pullRight fill onClick={() => this.generateHabitualTardinessReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "absences" && startDate && endDate && 
            <Button bsStyle="primary" pullRight fill onClick={() => this.generateAbsencesReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "awol" && selectedYear &&
            <Button bsStyle="primary" pullRight fill onClick={() => this.generateAwolReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "pag-ibig" && startDate && endDate && 
            <Button bsStyle="primary" pullRight fill onClick={() => this.generatePagIbigReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "sss" && startDate && endDate && 
            <Button bsStyle="primary" pullRight fill onClick={() => this.generateSSSReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "phic" && startDate && endDate && 
            <Button bsStyle="primary" pullRight fill onClick={() => this.generatePhicReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {selectedAction === "leave-balance" && selectedYear &&
            <Button bsStyle="primary" pullRight fill onClick={() => this.generateLeaveBalanceReport()}>
              {loading ? "Generating..." : "Generate Report"}
            </Button>
          }
          {reportData && selectedAction === "birthday" &&
            <BirthdayReport reportData={reportData} selectedMonth={selectedMonth} />
          }
          {reportData && selectedAction === "undertime" &&
            <UndertimeReport reportData={reportData} startDate={startDate} endDate={endDate} />
          }
          {reportData && selectedAction === "tardiness" &&
            <TardinessReport reportData={reportData} startDate={startDate} endDate={endDate} />
          }
          {reportData && selectedAction === "habitual-tardiness" &&
            <HabitualTardinessReport reportData={reportData} year={selectedYear} />
          }
          {reportData && selectedAction === "absences" &&
            <AbsencesReport reportData={reportData} startDate={startDate} endDate={endDate} />
          }
          {reportData && selectedAction === "awol" &&
            <AwolReport reportData={reportData} year={selectedYear} />
          }
          {reportData && selectedAction === "sss" &&
            <SSSReport reportData={reportData} startDate={startDate} endDate={endDate} />
          }
          {reportData && selectedAction === "phic" &&
            <PhicReport reportData={reportData} startDate={startDate} endDate={endDate} />
          }
          {reportData && selectedAction === "pag-ibig" &&
            <PagIbigReport reportData={reportData} startDate={startDate} endDate={endDate} />
          }
          {reportData && selectedAction === "leave-balance" &&
            <LeaveBalanceReport reportData={reportData} year={selectedYear} />
          }
        </Grid>
      </div>
    );
  }
}

export default Report;
